import pluralize from 'pluralize';

import { type GetBoardStatsResponse } from '@air/api';
import { formatBytes } from '@air/utilities';

export const formatBoardStats = (stats: GetBoardStatsResponse) => {
  const statsArray = [];

  if (stats.subBoardCount) {
    statsArray.push(pluralize('board', stats.subBoardCount, true));
  }

  if (stats.assetCount) {
    statsArray.push(pluralize('asset', stats.assetCount, true));
  }

  if (stats.fileCount) {
    statsArray.push(pluralize('file', stats.fileCount, true));
  }

  if (stats.sizeBytes) {
    statsArray.push(formatBytes(stats.sizeBytes));
  }

  return statsArray;
};

type FormatCurrentLevelBoardStatsParams = {
  boardStats: GetBoardStatsResponse;
  directDescendantBoardCount: number | undefined;
  /** Expanded nested content shows its assets inline and hides the boards, so the board count is dropped. */
  isFlattenedView: boolean;
};

/** The "N boards · N assets · N files · size" line for the board in view, matching what the gallery shows. */
export const formatCurrentLevelBoardStats = ({
  boardStats,
  directDescendantBoardCount,
  isFlattenedView,
}: FormatCurrentLevelBoardStatsParams) =>
  formatBoardStats({
    ...boardStats,
    subBoardCount: isFlattenedView ? 0 : (directDescendantBoardCount ?? boardStats.subBoardCount),
  }).join(' · ');
